export const WA_NUMBER = "6281234567890";
export const WA_DISPLAY = "+62 812-3456-7890";
export const IG_HANDLE = "@mulyono.cianjay";

export const IMG = {
  potret: "/images/potret-resmi.png",
  ronda: "/images/pos-ronda.png",
  wota: "/images/wota-lightstick.png",
  mancing: "/images/mancing.png",
  bantuan: "/images/bantuan-lansia.png",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
